import {environment} from "../../../environments/environment";

function createUrl(actionName: string): string {
  return `${environment.apiBaseUrl}${environment.apiUrl}${environment.apiVersion}${actionName}`;
}

export const TicketApiResources = {
  // Core CRUD
  list: createUrl('ticket'),
  search: createUrl('ticket/search'),
  detail: createUrl('ticket'),
  create: createUrl('ticket/create'),
  copy: createUrl('ticket'),
  update: createUrl('ticket'),  // PATCH /{id}
  delete: createUrl('ticket'),  // DELETE /{id}
  deleteMultiple: createUrl('ticket/delete/multiple'),
  deleteAvailability: createUrl('ticket/delete/availability'),

  // Status & Priority
  changeStatus: createUrl('ticket/change-status'),
  updatePriority: createUrl('ticket/update-priority'),
  statuses: createUrl('statuses/ticket'),  // Generic status API with module filter

  // Stages (Generic API with module_id filter)
  stages: createUrl('stages'),

  // Milestones (Generic API)
  milestones: createUrl('module-data-milestones'),

  // Tags (Generic API with module_id=8)
  tags: createUrl('user/tags'),
  createTag: createUrl('user/tags'),
  deleteTag: createUrl('user/tags'),  // DELETE /{id}

  // Favorites (Generic API with module_id=8)
  favoriteMark: createUrl('user/favorites/mark'),
  deleteFavorite: createUrl('user/favorites/delete'),  // DELETE /{id}

  // Materials & Services line items.
  // The Item typeahead lists the scope items of the job the ticket sits on
  // (TicketController@searchJobScopeItems); Assignee uses the same staff search
  // the ticket mentions already use.
  // Materials & Services. The picker lists the job's scope items split by
  // item_type (App\Models\Product = material, App\Models\Service = service);
  // "Add Selected" attaches them in one call.
  searchJobScopeItems: createUrl('ticket/job-scope-items/search'),
  ticketJobScopes: createUrl('ticket/job-scopes'),   // GET /{jobId}
  addTicketItems: createUrl('ticket/add/items'),
  deleteTicketItem: createUrl('ticket/item'),        // DELETE /{id}

  // Comments
  comments: createUrl('ticket/get-comments'),
  addComment: createUrl('ticket/add-comment'),
  commentReactions: createUrl('ticket/comments'),  // POST /{commentId}/reactions

  // Attachments
  addAttachment: createUrl('ticket/add-attachment'),

  // Checklists
  getChecklists: createUrl('ticket/get-checklists'),
  addChecklist: createUrl('ticket/add/checklist'),
  updateChecklist: createUrl('ticket/update/checklist'),
  deleteChecklist: createUrl('ticket/checklist'),  // DELETE /{id}

  // People/Associations
  addResponsiblePerson: createUrl('ticket/add/responsible/person'),
  addObserver: createUrl('ticket/add/observer'),
  addParticipant: createUrl('ticket/add/participant'),
  deleteAssociation: createUrl('ticket/association'),  // DELETE /{id}

  // History
  history: createUrl('ticket-history'),

  // Ticket-specific lookups
  customers: createUrl('ticket/customers'),
  vendors: createUrl('ticket/vendors'),
  subcontractors: createUrl('ticket/subcontractors'),
  // Module-scoped lookups: the backend narrows by the ticket's module (Job today).
  // Separate from the two above, which are left as they are.
  scopedVendors: createUrl('ticket/scoped/vendors'),
  scopedSubcontractors: createUrl('ticket/scoped/subcontractors'),

  // Module-level tickets
  moduleTickets: createUrl('module/tickets')  // GET /{module_id}/{reference_id}
};

// Module ID constant for tickets
export const TICKET_MODULE_ID = 8;
